import { ApiService } from "@/libs";
const CryptoJS = require("crypto-js");

/*
 * 获取图片src
 * */
export function getImgSrc(srcPath, size, isPreview = true) {
	if (srcPath.startsWith("prod") || srcPath.startsWith("series")) {
		return `${ApiService.ImageHost}/${srcPath}_${size}x${size}.jpg`;
	} else {
		let previewStr = isPreview ? `?x-oss-process=image/resize,w_${size}` : "";
		return `${ApiService.OssLook}/${srcPath}${previewStr}`;
	}
}

/**
 * 异步加载网络js资源
 * @param {string} _variable
 * @param {string} url
 * @param {[]} attrs
 * @returns {Promise}
 * @constructor
 */
export function JsLoad(_variable, url, attrs = []) {
	return new Promise((resolve, reject) => {
		if (!_variable && js_list.indexOf(url.toLowerCase()) >= 0) {
			resolve();
		} else if (_variable && window[_variable]) {
			resolve(window[_variable]);
		} else {
			let onReady = function () {
				!_variable && js_list.push(url.toLowerCase());
				resolve(_variable && window[_variable]);
			};
			let _script = document.createElement("script");
			_script.src = url;
			_script.type = "text/javascript";
			attrs &&
				Object.keys(attrs).forEach((_key) => {
					_script[_key] = attrs[_key];
				});
			_script.onload = onReady;
			document.body.appendChild(_script);
		}
	});
}

//获取地址栏参数
export function getUrlParam(name) {
	var reg = new RegExp("[?&]" + name + "=([^&#]*)", "i");
	var res = window.location.href.match(reg);

	if (res && res.length > 1) {
		return decodeURIComponent(res[1]);
	}
	return "";
}

/**
 * @description 获取文件后缀
 * @param {String} str 文件名
 * @param {Boolean} returnName 是否返回文件名
 * @param {Boolean} inluceDot 是否包含 .
 */
export function getSuffix(str, ops = { name: false, dot: true }) {
	let reg = /(.+)\.(.+)/g;
	if (typeof str !== "string" || !str) {
		return "";
	}
	str = str.substring(str.lastIndexOf("/") + 1);
	reg.exec(str);
	if (ops && ops.name) {
		return [RegExp.$1, RegExp.$2.toLowerCase()]; // ['文件名' ,'excel']
	} else {
		if (ops.dot) {
			return "." + RegExp.$2.toLowerCase();
		} else {
			return RegExp.$2.toLowerCase();
		}
	}
}

/**
 * @description 获取图片文件的临时url
 * @param {File} file
 * @return {*} url
 */
export function getObjectURL(file) {
	var url = null;
	if (window.createObjectURL != undefined) {
		// basic
		url = window.createObjectURL(file);
	} else if (window.URL != undefined) {
		// mozilla(firefox)
		url = window.URL.createObjectURL(file);
	} else if (window.webkitURL != undefined) {
		// webkit or chrome
		url = window.webkitURL.createObjectURL(file);
	}
	return url;
}

export function includesCheck(data, checkArr = []) {
	let check = false;
	for (let index = 0; index < checkArr.length; index++) {
	  const element = checkArr[index];
	  if (data.includes(element)) {
		check = true;
		break;
	  }
	}
	return check;
  }

export function decryptPhone(encryptedPhone) {
      const key = CryptoJS.enc.Utf8.parse("M@iDi_Yun#9$P!6K");
      const iv = CryptoJS.enc.Utf8.parse("8aF2cH4eR7sW1pL3");
      const text = CryptoJS.AES.decrypt(encryptedPhone, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
      return text.toString(CryptoJS.enc.Utf8);
    }
